<template>
  <nav class="sm:hidden" aria-label="Back">
    <ContextualRouterLink :to="props.pages.at(-2).href" class="flex items-center text-sm font-medium text-gray-500 hover:text-gray-700">
      <ChevronLeftIcon class="-ml-1 mr-1 h-5 w-5 flex-shrink-0 text-gray-400" aria-hidden="true" />
      Back
    </ContextualRouterLink>
  </nav>
  <nav class="hidden sm:flex" aria-label="Breadcrumb">
    <ol role="list" class="flex items-center space-x-4">
      <li v-for='page, index in props.pages'>
        <div class="flex items-center">
          <ChevronRightIcon class="h-5 w-5 flex-shrink-0 text-gray-400 mr-4" aria-hidden="true" v-if='index !== 0' />
          <ContextualRouterLink :to="page.href" class="text-sm font-medium text-gray-500 hover:text-gray-700" :aria-current="page.current ? 'page' : undefined">{{ page.name }}</ContextualRouterLink>
        </div>
      </li>
    </ol>
  </nav>
</template>

<script setup>

import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/vue/20/solid';

import ContextualRouterLink from '@/components/links/contextual-router-link.vue';

const props = defineProps({
  pages: Array
});

</script>
